import baseService from '@common/services/base.service';
import store from '@common/store/store';

const authRoute = window.api_routes.smarAPD_Authorization_Domain;
const defaultAuthHeaders = {
  Accept: 'application/json; version=2.0',
};

let http = baseService(store);

const apidDef = {
  getPasswordScore(password) {
    return http.post(
      `${authRoute}/configuracao/forca-senha`,
      { Senha: password },
      {
        noLoading: true,
        headers: defaultAuthHeaders,
      }
    );
  },
};

export default apidDef;
